import { render, staticRenderFns } from "./BookingModal.vue?vue&type=template&id=ad10f05c&"
import script from "./BookingModal.vue?vue&type=script&lang=js&"
export * from "./BookingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad10f05c')) {
      api.createRecord('ad10f05c', component.options)
    } else {
      api.reload('ad10f05c', component.options)
    }
    module.hot.accept("./BookingModal.vue?vue&type=template&id=ad10f05c&", function () {
      api.rerender('ad10f05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/BookingModal.vue"
export default component.exports